module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_HR-db7c07343d14602cb08c4808e49ed553.svg";